import {
  WSContainer,
  WSGrid,
  WSScreen
} from "@wingspanhq/fe-component-library";
import * as React from "react";
import { useHistory } from "react-router-dom";
import { BrowserPageTitle } from "../../components/BrowserPageTitle/BrowserPageTitle";
import { FeatureInfo } from "../components/FeatureInfo/FeatureInfo";
import { OnboardingHeader } from "../components/OnboardingHeader/OnboardingHeader";
import { SubscriptionWidget } from "../components/SubscriptionWidget/SubscriptionWidget";

interface OnboardingStep4PaymentsProps {}
export const OnboardingStep4Payments: React.FC<OnboardingStep4PaymentsProps> = () => {
  const history = useHistory();
  const onBack = () => {
    history.push("/member/onboarding/step/3/payments");
  };
  return (
    <>
      <BrowserPageTitle title="Onboarding: Step 4 | Payments" />
      <OnboardingHeader onBack={onBack} />
      <WSContainer verticalPadding>
        <WSGrid.Container>
          <WSGrid.Item XS={6} M={6}>
            <WSScreen.Mobile>
              <FeatureInfo
                title="Get paid your way, on your time."
                featureItems={[
                  "Supercharged custom invoices",
                  "Personal pay link – send a text, get paid",
                  "Automated late invoice follow-ups"
                ]}
                virtualAssistantMessage="Wingspan is entirely tax deductible! And – you guessed it – we'll deduct it for you."
              />
            </WSScreen.Mobile>
            <WSScreen.TabletAndDesktop>
              <FeatureInfo
                title="Get paid your way, on your time."
                description="Wingspan's powerful payments tools put more money in your
                pocket, faster, and give your clients ultimate flexibility."
                featureItems={[
                  "Supercharged custom invoices",
                  "Personal pay link – send a text, get paid",
                  "Late invoice follow-ups, completely automated",
                  "Uplifting emails when you get paid",
                  "Easy subcontractor payments"
                ]}
                virtualAssistantMessage="Wingspan is entirely tax deductible! And – you guessed it – we'll deduct it for you."
              />
            </WSScreen.TabletAndDesktop>
          </WSGrid.Item>
          <WSGrid.Item XS={6} M={6}>
            <SubscriptionWidget />
          </WSGrid.Item>
        </WSGrid.Container>
      </WSContainer>
    </>
  );
};
